<!-- 异常记录win窗 -->
<template>
    <div class="height-percent-100 p15">
        <carrierAbnormal :detailObj="detailObj" v-if="detailObj"></carrierAbnormal>
    </div>
</template>

<script>
import carrierAbnormal from '@/pages/business/components/detail/carrierAbnormal.vue'
import detailObj from "./mixin/detailObj";

export default {
    mixins:[detailObj],
    components:{
        carrierAbnormal
    },
    mounted(){

    }
}
</script>

<style lang="scss" scoped>
.p15{
    padding: 15px;
    box-sizing: border-box;
}
</style>